import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'
import type { QueryClient } from '@tanstack/react-query'
import type { AuthState } from '@/lib/auth'

/**
 * Kontext routeru. Diky nemu ma `beforeLoad` v kazde ceste typovany pristup
 * ke stavu prihlaseni a ke query klientovi — data se tak daji nacist jeste
 * pred vykreslenim, bez spinneru uvnitr komponent.
 */
export interface RouterContext {
  auth: AuthState
  queryClient: QueryClient
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => <Outlet />,
  notFoundComponent: () => (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <p className="text-4xl font-bold text-slate-300">404</p>
        <p className="mt-2 text-sm text-slate-500">Tahle stranka neexistuje.</p>
      </div>
    </div>
  ),
})
